// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"e84609e6","5122":"1f3a2121","7433":"3e7f4363","8360":"b78d9271","8887":"3106b8ee"}[chunkId] + ".css";
};